import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Fade, makeStyles } from '@material-ui/core';
import CustomButton from '../customButton';
import Header from './header';
import Body from './body';

const useStyles = makeStyles(({ palette: { primary }, spacing }) => ({
  table: {
    display: 'grid',
  },
  loadMoreWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: spacing(4),
    width: '100%',
  },
  loadMoreButton: {
    border: `1px solid ${primary.bluish3}`,
    borderRadius: 44,
    color: primary.bluish4,
    lineHeight: '24px',
    justifySelf: 'center',
    padding: spacing(1, 4),
    maxHeight: 32,
  },
}));

const CyclesTable = ({
  className = null,
  headerClass = null,
  translations = {},
  headers,
  rows = [],
  reviewTypes,
  initialSort = {},
  headerActions = [],
  hasLoadMore = false,
  canManage,
  onLoadMore = () => {},
  onSort = () => {},
  onViewReviews,
  prepareReviewDetailsUrl,
  onSendReminder,
  onRenameReview,
  onFillReview,
}) => {
  const classes = useStyles();
  const headerItems = [...headers, ...headerActions];

  return (
    <div className={classNames(classes.table, className)}>
      <Header
        headerClass={headerClass}
        headers={headerItems}
        initialSort={initialSort}
        onSort={onSort}
      />
      <Body
        translations={translations}
        headers={headerItems}
        rows={rows}
        reviewTypes={reviewTypes}
        canManage={canManage}
        onViewReviews={onViewReviews}
        prepareReviewDetailsUrl={prepareReviewDetailsUrl}
        onFillReview={onFillReview}
        onSendReminder={onSendReminder}
        onRenameReview={onRenameReview}
      />
      <Fade in={hasLoadMore} unmountOnExit>
        <div className={classes.loadMoreWrapper}>
          <CustomButton
            type="addWithTextRounded"
            className={classes.loadMoreButton}
            onClick={onLoadMore}
          >
            {translations.loadMore}
          </CustomButton>
        </div>
      </Fade>
    </div>
  );
};

CyclesTable.propTypes = {
  className: PropTypes.string,
  translations: PropTypes.shape({}),
  headerClass: PropTypes.string,
  initialSort: PropTypes.object,
  rows: PropTypes.arrayOf(PropTypes.object),
  reviewTypes: PropTypes.arrayOf(PropTypes.object).isRequired,
  headerActions: PropTypes.arrayOf(PropTypes.shape({})),
  hasLoadMore: PropTypes.bool,
  canManage: PropTypes.bool.isRequired,
  onLoadMore: PropTypes.func,
  onSort: PropTypes.func,
  onViewReviews: PropTypes.func.isRequired,
  prepareReviewDetailsUrl: PropTypes.func.isRequired,
  onFillReview: PropTypes.func.isRequired,
  onSendReminder: PropTypes.func.isRequired,
  onRenameReview: PropTypes.func.isRequired,
};

export default CyclesTable;
